import 'css-chunk:src/feature/provision/StepperFooter.module.scss';export default {
  "container": "StepperFooter_container"
};